import { createSelector } from 'reselect';
import { getCurrentPageId, getInstanceId, getCompId, getSiteUrl } from 'shared/selectors/app-settings';
import getUrlToVideo from '@wix/wix-vod-shared/src/common/utils/get-url-to-video';
import getUrlToChannel from '@wix/wix-vod-shared/src/common/utils/get-url-to-channel';

const getUrlToVideoSafe = (videoItem, params) => {
  if (!videoItem) {
    return null;
  }
  return getUrlToVideo(videoItem, params);
};

export const getShareMode = state => state.shareOverlay.shareMode;
export const isShareOverlayOpen = state => state.shareOverlay.isOpen;
export const getInstanceInfo = createSelector(
  getInstanceId,
  getCompId,
  getCurrentPageId,
  (instanceId, componentId, sitePageId) => ({ instanceId, componentId, sitePageId })
);


export const getVideoUrl = createSelector(
  (state, ownProps) => ownProps.videoItem,
  getCompId,
  getSiteUrl,
  (videoItem, compId, siteUrl) => getUrlToVideoSafe(videoItem, { compId, siteUrl })
);

export const getChannelUrl = createSelector(
  getCompId,
  getSiteUrl,
  (compId, siteUrl) => getUrlToChannel({ siteUrl, compId })
);



// WEBPACK FOOTER //
// ./src/widget/selectors/share-overlay.js